'use client'

import { useState } from 'react'
import Link from 'next/link'

import styles from '../jobs.module.scss'

type JobsStatesSectionProps = {
  locale: string
  states: string[]
}

export default function JobsStatesSection({ locale, states }: JobsStatesSectionProps): JSX.Element {
  const [showAll, setShowAll] = useState(false)
  
  // Show first 20 states initially, then all when expanded
  const visibleStates = showAll ? states : states.slice(0, 20)
  const hasMore = states.length > 20

  return (
    <section className={styles.jobsStatesSection}>
      <div className={styles.jobsStatesContainer}>
        <div className={styles.jobsStatesCard}>
          <h2 className={styles.jobsStatesTitle}>By state</h2>
          <div className={styles.jobsStatesList}>
            {visibleStates.map((state) => {
              // State abbreviations are already uppercase from the API
              const stateAbbr = state.toUpperCase()
              const url = `/${locale}/jobs/state/${encodeURIComponent(state.toUpperCase())}`
              
              return (
                <Link
                  key={state}
                  href={url}
                  className={styles.jobsStateLink}
                >
                  {stateAbbr}
                </Link>
              )
            })}
          </div>
          {hasMore && (
            <button
              onClick={() => setShowAll(!showAll)}
              className={styles.jobsStatesToggle}
            >
              {showAll ? 'Show less' : `Show all ${states.length} states`}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className={`${styles.jobsStatesToggleIcon} ${showAll ? styles.jobsStatesToggleIconRotated : ''}`}
              >
                <path d="m6 9 6 6 6-6"></path>
              </svg>
            </button>
          )}
        </div>
      </div>
    </section>
  )
}
